"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var production_exports = {};
__export(production_exports, {
  productionMaps: () => productionMaps
});
module.exports = __toCommonJS(production_exports);
var import_MapInventory = require("./MapInventory.js");
var import_arrt = require("./maps/arrt/index.js");
var import_esrt = require("./maps/esrt/index.js");
var import_fba = require("./maps/fba/index.js");
var import_fht = require("./maps/fht/index.js");
var import_FhtPriorityPonds = require("./maps/fht/FhtPriorityPonds.js");
var import_mrs = require("./maps/mrs/index.js");
var import_nwc = require("./maps/nwc/index.js");
var import_placemarker = require("./maps/placemarker/index.js");
var import_priorityhabitats = require("./maps/priorityhabitats/index.js");
var import_riverfly = require("./maps/riverfly/index.js");
var import_royalparks = require("./maps/royalparks/index.js");
var import_salmontrout = require("./maps/salmontrout/index.js");
var import_sas = require("./maps/sas/index.js");
var import_standard = require("./maps/standard/index.js");
var import_storm = require("./maps/storm/index.js");
var import_thames21 = require("./maps/thames21/index.js");
var import_ucl = require("./maps/ucl/index.js");
var import_urs = require("./maps/urs/index.js");
var import_wrt = require("./maps/wrt/index.js");
var import_WrtLevelLoggers = require("./maps/wrt/WrtLevelLoggers.js");
function productionMaps() {
  return new import_MapInventory.MapInventory([
    import_arrt.OutfallSafari,
    import_arrt.ArrtWaterQuality,
    import_esrt.EsrtWaterQuality,
    import_riverfly.ExtendedRiverflyWaterQuality,
    import_riverfly.ExtendedRiverflySiltAndFlow,
    import_fba.FbaWindermere,
    import_fba.FbaWindermereSite,
    import_fht.FhtPondCount,
    import_FhtPriorityPonds.FhtPriorityPonds,
    import_mrs.MrsMorph,
    import_mrs.MrsMorph10,
    import_mrs.MrsMorph10Pro,
    import_mrs.MrsMorph5,
    import_mrs.MrsMorph5Pro,
    import_mrs.MrsMorphEstuaries,
    import_mrs.MrsMorphEstuariesPro,
    import_mrs.MrsMorphPro,
    import_mrs.MrsMorphRivers,
    import_mrs.MrsMudSpotter,
    import_mrs.MrsRiverCondition,
    import_mrs.MrsRiverConditionPro,
    import_mrs.MrsRiverWood,
    import_mrs.MrsRcaPro,
    import_mrs.MrsRta,
    import_mrs.MrsRtaPro,
    import_mrs.MrsWildInvaders,
    import_priorityhabitats.NeChalkRivers,
    import_priorityhabitats.NeLakeNaturalness,
    import_priorityhabitats.NeLakeRestorationPriorities,
    import_priorityhabitats.NeNaturalness,
    import_priorityhabitats.NeRestorationPriorities,
    import_priorityhabitats.NeRiverNaturalness,
    import_priorityhabitats.NeRiverRestorationPriorities,
    import_priorityhabitats.NeRiverTypes,
    import_nwc.NwcSeedbank,
    import_placemarker.PlacemarkerRiverStretch,
    import_placemarker.PlacemarkerStudyArea,
    import_riverfly.Riverfly,
    import_riverfly.RiverflySite,
    import_royalparks.RoyalParksSpotlighting,
    import_sas.SasWaterQuality,
    import_sas.SasWaterQualitySite,
    import_standard.StdActivityDiary,
    import_standard.StdInvasiveSpeciesSighting,
    import_storm.StormPhosphates,
    import_salmontrout.StSmartRivers,
    import_salmontrout.StSmartRiversSite,
    import_thames21.Thames21BadgedGroupEvent,
    import_thames21.Thames21GreenWallModule,
    import_thames21.Thames21Litter,
    import_thames21.Thames21SlowFlow,
    import_thames21.Thames21ThamesWaterQuality,
    import_thames21.Thames21Vegetation,
    import_thames21.Thames21WaterQuality,
    import_ucl.UclPitStop,
    import_riverfly.UrbanRiverfly,
    import_urs.Urs,
    import_wrt.WrtFords,
    import_WrtLevelLoggers.WrtLevelLoggers,
    import_wrt.WrtUpstreamThinking,
    import_wrt.WrtWestcountryCsi
  ]);
}
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {
  productionMaps
});
//# sourceMappingURL=production.js.map
